<div class="portrait-mode-container" #root>
    <div class="portrait-mode-content">
        <img style="padding-bottom: 23px" src="assets/landscape-mode.svg" />
        <span class="text">{{ 'tsd_default_portrait_mode' | localize | async }}</span>
    </div>
</div>
